import React, { useEffect, useContext, useState } from 'react';
import Post from './Post';
import styles from './MainContent.module.css';
import Header from './Header.js';
import MobileHeader from './MobileHeader.js';
import { PostContext } from '../../createContext/Post/PostContext';

function MainContent() {
  const { posts, getPosts } = useContext(PostContext);
  const [selectedPostId, setSelectedPostId] = useState(null);

  useEffect(() => {
    if (posts.length === 0)
      getPosts();
  }, []);

  const toggleComments = (postId) => {
    setSelectedPostId(selectedPostId === postId ? null : postId);
  };

  return (
    <>
      <main className={`${styles.mainContent}`}>
        <div className='bg-white w-full h-16 fixed z-1 -top-10 lg:z-30'></div>
        <MobileHeader />
        <Header />
        <div className={styles.postsContainer}>
          {posts && posts.map(post => (
            <React.Fragment key={post._id}>
              <Post 
                {...post} 
                toggleComments={toggleComments} 
                isCommentsVisible={selectedPostId === post._id}
              />
            </React.Fragment>
          ))}
        </div>
      </main>
    </>
  );
}

export default MainContent;